"use strict";
/**
 * AppPage ist das Einstiegsscript für das Crude
 * zuerst wird die CrudeConfiguration ausgewertet und die jeweiligen Elemente im Store gespeichert
 * dann wird das Schema und die Labels geladen und ebenso im Store gespeichert
 * aus dem Schema und der CrudeConfiguration werden danach die Tabs extrahiert/verifiziert
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var locales = __importStar(require("@mui/material/locale"));
var material_1 = require("@mui/material");
var schemaTypes_1 = require("./shared/types/schemaTypes");
var getFetchHeaders_1 = __importDefault(require("./shared/util/getFetchHeaders"));
var getCrudeAppTabs_1 = __importDefault(require("./shared/util/getCrudeAppTabs"));
var getDefaultAppConfig_1 = __importDefault(require("./defaults/getDefaultAppConfig"));
var getDefaultAppTheme_1 = __importDefault(require("./defaults/getDefaultAppTheme"));
var crudeActions = __importStar(require("./store/crude/crude.actions"));
var crude_actions_1 = require("./store/crude/crude.actions");
var loadSchema_1 = __importDefault(require("./fetch/loadSchema"));
var loadLanguageLabels_1 = __importDefault(require("./fetch/loadLanguageLabels"));
var CrudeAppComponents_1 = __importDefault(require("./screens/CrudeAppComponents"));
var crude_selector_1 = require("./store/crude/crude.selector");
var commonTypes_1 = require("./shared/types/commonTypes");
var licenseTypes_1 = require("./shared/types/licenseTypes");
var loadListEntityData_1 = __importDefault(require("./fetch/loadListEntityData"));
var getDefaultTableFilterSettings_1 = __importDefault(require("./defaults/getDefaultTableFilterSettings"));
var react_i18next_1 = require("react-i18next");
var getCompleteConfig_1 = __importDefault(require("./shared/util/getCompleteConfig"));
var AppPage = function (props) {
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation().t;
    var _a = react_1.useState(false), settingsReady = _a[0], setSettingsReady = _a[1];
    var _b = react_1.useState(false), licenseReady = _b[0], setLicenseReady = _b[1];
    var _c = react_1.useState(), crudeSchema = _c[0], setCrudeSchema = _c[1];
    var _d = react_1.useState(), crudeLabels = _d[0], setCrudeLabels = _d[1];
    var _e = react_1.useState([]), referenceQueue = _e[0], setReferenceQueue = _e[1];
    var _f = react_1.useState({}), crudeFilter = _f[0], setCrudeFilter = _f[1];
    var theme = props.crudeConfig.theme || getDefaultAppTheme_1.default(false, 'blue');
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var storedCrudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels);
    var crudeConfig = props.crudeConfig;
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var defaultFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    // Konfiguration aus der CrudeConfiguration extrahieren, ggf. defaults setzen
    var defaultAppLayout = getDefaultAppConfig_1.default();
    var appLayout = crudeConfig.appLayout || defaultAppLayout;
    if ((appLayout.elements && appLayout.elements.length < 1) || !appLayout.elements) {
        appLayout.elements = defaultAppLayout.elements;
    }
    var editLayout = crudeConfig.editLayout;
    var crudePath = crudeConfig.path;
    var themeWithLocale = react_1.default.useMemo(function () {
        var locale = crudeLanguage.toString().replace('-', '');
        return material_1.createTheme(theme, locales[locale]);
    }, [crudeLanguage, theme]);
    var setReferenceFilter = function (response, reference) {
        var _a, _b;
        if (response) {
            var newFilterOptions_1 = [];
            var entitySchema_1 = reference && (crudeSchema === null || crudeSchema === void 0 ? void 0 : crudeSchema.find(function (schema) { return schema.name === reference.targetEntity; }));
            (_a = response.data) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                reference && entitySchema_1 && newFilterOptions_1.push({
                    key: "" + elem[entitySchema_1 === null || entitySchema_1 === void 0 ? void 0 : entitySchema_1.idColumn],
                    value: response.entityReferencePreviews[reference.targetEntity][elem[entitySchema_1 === null || entitySchema_1 === void 0 ? void 0 : entitySchema_1.idColumn]],
                });
            });
            // neue options für die Filter extrahieren
            var newEntityFilter_1 = [];
            reference && ((_b = crudeFilter[reference.sourceEntity]) === null || _b === void 0 ? void 0 : _b.map(function (filter) {
                if (filter.name === "value_" + reference.sourceColumn) {
                    newEntityFilter_1.push(__assign(__assign({}, filter), { options: newFilterOptions_1 }));
                }
                else {
                    newEntityFilter_1.push(filter);
                }
            }));
            if (reference && crudeFilter[reference.sourceEntity]) {
                var newFilter = __assign({}, crudeFilter);
                newFilter[reference.sourceEntity] = newEntityFilter_1;
                setCrudeFilter(newFilter);
            }
        }
        var newQueue = [];
        referenceQueue.map(function (elem, index) {
            if (index !== 0) {
                newQueue.push(elem);
            }
        });
        setReferenceQueue(newQueue);
    };
    react_1.useEffect(function () {
        // wenn alle durchgelaufen sind, erst in den store speichern
        if (referenceQueue.length === 0) {
            dispatch(crudeActions.setCrudeFilter(crudeFilter));
            dispatch(crudeActions.loadFilterData(false));
        }
        var apiCall = referenceQueue[0];
        if (apiCall) {
            loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, apiCall.entity, fetchHeaders, apiCall.tableFilterSettings, undefined, undefined, setReferenceFilter, undefined, ['include_self_previews'], apiCall.reference);
        }
    }, [referenceQueue]);
    var extractFilter = function () {
        var filter = {};
        var loadRefQueue = [];
        crudeSchema && crudeSchema.map(function (entitySchema) {
            var _a, _b, _c;
            var entityFilterArray = [];
            // zunächst die vom BE gesetzten enum-filter extrahieren
            if (((_a = entitySchema.facets) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                entitySchema.facets.map(function (filter) {
                    var _a, _b, _c, _d, _e;
                    var options = [];
                    var filterExists = ((_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.facet) !== undefined;
                    filter.options.map(function (option) {
                        var _a, _b, _c, _d, _e, _f;
                        var label = filterExists
                            ? (_c = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.facet[filter.name]) === null || _b === void 0 ? void 0 : _b.options[option.name]) === null || _c === void 0 ? void 0 : _c.title : undefined;
                        var description = filterExists
                            ? (_f = (_e = (_d = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _d === void 0 ? void 0 : _d.facet[filter.name]) === null || _e === void 0 ? void 0 : _e.options[option.name]) === null || _f === void 0 ? void 0 : _f.description : undefined;
                        options.push({
                            key: option.name,
                            value: label || option.name,
                            description: description,
                        });
                    });
                    var label = filterExists
                        ? (_c = (_b = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _b === void 0 ? void 0 : _b.facet[filter.name]) === null || _c === void 0 ? void 0 : _c.title : undefined;
                    var description = filterExists
                        ? (_e = (_d = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _d === void 0 ? void 0 : _d.facet[filter.name]) === null || _e === void 0 ? void 0 : _e.description : undefined;
                    var filterObject = {
                        options: options,
                        name: filter.name,
                        label: label || filter.name,
                        description: description,
                    };
                    entityFilterArray.push(filterObject);
                });
            }
            // alle enum  / boolean columns als Filter setzen
            if (crudeLicense.standardFilter.available && appLayout.showStandardFilter) {
                var entityConfig = (_b = crudeConfig.tabs) === null || _b === void 0 ? void 0 : _b.find(function (elem) { return elem.entity === entitySchema.name; });
                var standardFilter_1 = (entityConfig === null || entityConfig === void 0 ? void 0 : entityConfig.standardFilter) || [];
                // zunächst werden die filter aus den tabs extrahiert, wenn aber keine tabs angeben sind oder die Lizenz für die erweiterten Tabellen nicht vorhanden ist, können über die columndefinitions zumindest alle Filter angegeben werden
                if ((!crudeConfig.tabs || !(entityConfig && entityConfig.standardFilter))) {
                    entitySchema.columns.map(function (col) {
                        if (col.columnType === schemaTypes_1.ColumnType.Enum || col.columnType === schemaTypes_1.ColumnType.Boolean) {
                            standardFilter_1.push({
                                columnName: col.name,
                                multiSelect: false,
                            });
                        }
                    });
                }
                entitySchema.columns.map(function (col) {
                    var _a, _b, _c, _d, _e;
                    var useFilter = standardFilter_1.find(function (filter) { return filter.columnName === col.name; });
                    if (useFilter) {
                        var columnLabels_1 = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entitySchema.name]) === null || _b === void 0 ? void 0 : _b.columns;
                        var label = (columnLabels_1 && ((_c = columnLabels_1[col.name]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels_1[col.name]) === null || _d === void 0 ? void 0 : _d.title : col.name;
                        if (col.columnType === schemaTypes_1.ColumnType.Enum) {
                            var options_1 = [];
                            var values = (_e = col.enumValues) !== null && _e !== void 0 ? _e : [];
                            values.length > 0 && values.map(function (key) {
                                var _a, _b, _c, _d;
                                var obj = {
                                    key: key,
                                    value: (columnLabels_1 && columnLabels_1[col.name] && columnLabels_1[col.name].options && ((_a = columnLabels_1[col.name]) === null || _a === void 0 ? void 0 : _a.options[key]))
                                        ? (_b = columnLabels_1[col.name]) === null || _b === void 0 ? void 0 : _b.options[key].title : key,
                                    description: (columnLabels_1 && columnLabels_1[col.name] && columnLabels_1[col.name].options && ((_c = columnLabels_1[col.name]) === null || _c === void 0 ? void 0 : _c.options[key])) && ((_d = columnLabels_1[col.name]) === null || _d === void 0 ? void 0 : _d.options[key].description),
                                };
                                options_1.push(obj);
                            });
                            var filterObject = {
                                options: options_1,
                                name: "value_" + col.name,
                                label: label,
                            };
                            entityFilterArray.push(filterObject);
                        }
                        if (col.columnType === schemaTypes_1.ColumnType.Boolean) {
                            var filterObject = {
                                options: [{
                                        key: 'true',
                                        value: t('crude:true'),
                                    },
                                    {
                                        key: 'false',
                                        value: t('crude:false'),
                                    }],
                                name: "value_" + col.name,
                                label: label,
                            };
                            entityFilterArray.push(filterObject);
                        }
                    }
                });
            }
            // optional die outgoingReferences als filter setzen
            if (crudeLicense.outgoingReferenceFilters.available && appLayout.showReferenceFilter) {
                var entityConfig = (_c = crudeConfig.tabs) === null || _c === void 0 ? void 0 : _c.find(function (elem) { return elem.entity === entitySchema.name; });
                var referenceFilter = entityConfig === null || entityConfig === void 0 ? void 0 : entityConfig.referenceFilter;
                // zunächst werden die filter aus den tabs extrahiert, wenn aber keine tabs angeben sind oder die Lizenz für die erweiterten Tabellen nicht vorhanden ist, können über die outgoingReferences zumindest alle Filter angegeben werden
                if ((!crudeConfig.tabs || !(entityConfig && entityConfig.referenceFilter))) {
                    referenceFilter = entitySchema.outgoingReferences;
                }
                referenceFilter === null || referenceFilter === void 0 ? void 0 : referenceFilter.map(function (reference) {
                    var _a;
                    if (!reference.manyToManyOppositeEntityName || reference.manyToManyOppositeEntityName === '') {
                        var columnLabels = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entitySchema.name].columns;
                        var label = columnLabels && columnLabels[reference.sourceColumn] && columnLabels[reference.sourceColumn].title;
                        var description = columnLabels && columnLabels[reference.sourceColumn] && columnLabels[reference.sourceColumn].description;
                        var filterObject = {
                            options: [],
                            name: "value_" + reference.sourceColumn,
                            label: label || reference.targetEntity,
                            description: description,
                        };
                        var tableFilterSettings = {
                            order: commonTypes_1.Order.asc,
                            orderBy: '',
                            page: 0,
                            pageSize: 1000,
                            search: '',
                            filter: {},
                        };
                        loadRefQueue.push({
                            entity: reference.targetEntity,
                            tableFilterSettings: tableFilterSettings,
                            reference: reference,
                        });
                        entityFilterArray.push(filterObject);
                    }
                });
            }
            filter[entitySchema.name] = entityFilterArray;
        });
        setCrudeFilter(filter);
        setReferenceQueue(loadRefQueue);
        setSettingsReady(true);
        dispatch(crudeActions.loadFilterData(true));
    };
    react_1.useEffect(function () {
        if (!storedCrudeLabels[crudeLanguage]) {
            crudeLicense.i18n.available && loadLanguageLabels_1.default(crudeConfig.api.restPath, crudeLanguage, fetchHeaders, setCrudeLabels);
        }
        setCrudeLabels(storedCrudeLabels[crudeLanguage]);
        crudeLabels && crudeSchema && extractFilter();
    }, [crudeLanguage]);
    react_1.useEffect(function () {
        // im store ablegen
        if (crudeLanguage && crudeLabels) {
            var newLabels = __assign({}, storedCrudeLabels);
            newLabels[crudeLanguage] = crudeLabels;
            dispatch(crudeActions.setCrudeLabels(newLabels));
            crudeSchema && extractFilter();
        }
    }, [crudeLabels]);
    react_1.useEffect(function () {
        var _a;
        // wenn das Schema geladen ist, werden die AppTabs daraus extrahiert oder die in der CrudeConfig angegebenen Tabs verifiziert
        if (crudeSchema) {
            dispatch(crudeActions.setCrudeSchema(crudeSchema));
            var crudeAppTabs = getCrudeAppTabs_1.default(crudeLicense.extendedNavigation.available, crudeConfig, crudeSchema);
            dispatch(crudeActions.setCrudeTabs(crudeAppTabs));
            // finetuning der App
            var newFilterSettings_1 = __assign({}, defaultFilterSettings);
            var defaultSettings = __assign({}, getDefaultTableFilterSettings_1.default());
            if (appLayout.initialPageSize) {
                defaultSettings.pageSize = appLayout.initialPageSize;
            }
            // initiale Filter für alle Entities setzen
            var newSettings_1 = defaultSettings;
            (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (selectedEntity) {
                var _a;
                var entityName = selectedEntity.entity;
                var sortingColumn = (_a = selectedEntity.columns) === null || _a === void 0 ? void 0 : _a.find(function (col) { return col.sort; });
                newFilterSettings_1[entityName] = {};
                if (sortingColumn && sortingColumn.sort) {
                    newSettings_1 = __assign(__assign({}, newSettings_1), { orderBy: sortingColumn.name, order: sortingColumn.sort });
                    newFilterSettings_1[entityName][0] = newSettings_1;
                }
                else {
                    newFilterSettings_1[entityName][0] = getDefaultTableFilterSettings_1.default();
                }
            });
            crudeSchema.map(function (entity) {
                if (!newFilterSettings_1[entity.name]) {
                    newFilterSettings_1[entity.name] = {};
                    newFilterSettings_1[entity.name][0] = getDefaultTableFilterSettings_1.default();
                }
            });
            dispatch(crudeActions.setTableFilterSettings(newFilterSettings_1));
        }
        extractFilter();
        // im store ablegen
        dispatch(crudeActions.setCrudePath(crudePath));
        dispatch(crudeActions.setAppLayout(appLayout));
        editLayout && crudeLicense.extendedEditForms.available && dispatch(crudeActions.setEditLayout(editLayout));
    }, [crudeSchema]);
    // wenn Lizenzen geladen sind, dann schema und languages nachladen
    react_1.useEffect(function () {
        if (licenseReady) {
            // Laden von Schema und Labels
            loadSchema_1.default(crudeConfig.api.restPath, crudeConfig.api.app, fetchHeaders, setCrudeSchema);
            if (!storedCrudeLabels[crudeLanguage]) {
                crudeLicense.i18n.available && loadLanguageLabels_1.default(crudeConfig.api.restPath, crudeLanguage, fetchHeaders, setCrudeLabels);
            }
        }
    }, [licenseReady]);
    // zuerst die Lizenzen laden
    react_1.useEffect(function () {
        var _a, _b, _c, _d, _e;
        var screenWidth = window.screen.availWidth;
        if (screenWidth < 576 && ((_b = (_a = crudeConfig.crudeLicense) === null || _a === void 0 ? void 0 : _a.responsiveViews) === null || _b === void 0 ? void 0 : _b.available)) {
            dispatch(crude_actions_1.setScreenDesign(commonTypes_1.ScreenDesign.mobile));
        }
        if (screenWidth >= 576 && screenWidth < 768 && ((_d = (_c = crudeConfig.crudeLicense) === null || _c === void 0 ? void 0 : _c.responsiveViews) === null || _d === void 0 ? void 0 : _d.available)) {
            dispatch(crude_actions_1.setScreenDesign(commonTypes_1.ScreenDesign.tablet));
        }
        if (screenWidth >= 768) {
            dispatch(crude_actions_1.setScreenDesign(commonTypes_1.ScreenDesign.desktop));
        }
        // TODO laden der Lizenzen
        var licenseObject = __assign({}, crudeLicense);
        if (crudeConfig.crudeLicense) {
            Object.keys(licenseTypes_1.License).map(function (lic) {
                if (crudeConfig.crudeLicense && crudeConfig.crudeLicense[lic]) {
                    licenseObject[lic] = crudeConfig.crudeLicense[lic];
                }
                else {
                    licenseObject[lic] = { available: false };
                }
            });
        }
        dispatch(crudeActions.setCrudeLicense(licenseObject));
        setLicenseReady(true);
        // prüfen, ob lokale Config vorliegt und beide Configs mergen, wenn die geladene Config nicht komplett neu ist
        var lastCrudeConfig = window.localStorage.getItem('officialCrudeConfiguration');
        if (lastCrudeConfig && ((_e = JSON.parse(lastCrudeConfig)) === null || _e === void 0 ? void 0 : _e.api.app) !== crudeConfig.api.app) {
            // prüfen, ob es die richtige ist > bei lokaler ENtwickliung nötig
            lastCrudeConfig = null;
        }
        var localConfig = window.localStorage.getItem('personalCrudeConfiguration') && JSON.parse(window.localStorage.getItem('personalCrudeConfiguration') || '');
        if ((localConfig === null || localConfig === void 0 ? void 0 : localConfig.api.app) !== crudeConfig.api.app) {
            localConfig = null;
        }
        var mergeConfigs = true;
        if (lastCrudeConfig && JSON.stringify(JSON.parse(lastCrudeConfig).tabs) !== JSON.stringify(props.crudeConfig.tabs)) {
            mergeConfigs = false;
            window.localStorage.setItem('officialCrudeConfiguration', JSON.stringify(props.crudeConfig));
        }
        var completeConfig = mergeConfigs && localConfig ? getCompleteConfig_1.default(props.crudeConfig, localConfig) : props.crudeConfig;
        dispatch(crudeActions.setCrudeConfiguration(completeConfig));
    }, []);
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: themeWithLocale },
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement("div", { className: 'root', style: { width: '100%', padding: '15px' } }, settingsReady && react_1.default.createElement(CrudeAppComponents_1.default, null)))));
};
exports.default = AppPage;
